import {delegateListener} from './delegate-listener.js';

const setBannerInfo = () => {
    const closeBannerBtnSelector = '.js-close-banner-info';
    delegateListener('click', closeBannerBtnSelector, e => {
        e.preventDefault();
        const btn = e.target.closest(closeBannerBtnSelector);
        if (!btn) return;
        const banner = btn.closest('.banner-info');
        if (!banner) return;
        banner.remove();
    });
};
setBannerInfo();
